import { cn } from '@fshr/shared-react';

const DOT_DELAYS = ['0s', '0.2s', '0.4s'];

export default function PulsingDots({ className }: { className?: string }) {
	return (
		<div
			className={cn('flex h-[22px] w-full items-center gap-[5px]', className)}
			data-testid="pulsing-dots"
		>
			{DOT_DELAYS.map(animationDelay => (
				<span
					key={animationDelay}
					className="h-[6px] w-[6px] animate-pulse rounded-full bg-text-heading"
					style={{ animationDelay }}
				/>
			))}
		</div>
	);
}
